"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mask = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _excluded = ["className", "active", "onClick", "style"];
var Mask = function Mask(props) {
  var className = props.className,
    active = props.active,
    onClick = props.onClick,
    style = props.style,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('mask'), className, (0, _defineProperty2.default)({}, "".concat((0, _getPrefixCls.getPrefixCls)('mask__active')), active)),
    onClick: onClick,
    "aria-hidden": true // @ts-ignore
    ,

    style: style
  }, rest));
};
exports.Mask = Mask;